import React from 'react'
import { Box } from '@mui/material'
import TruncatedText from './TruncatedText'

interface TableHeaderProps {
    text: string
}

const EntityTableHeader: React.FC<TableHeaderProps> = ({ text }) => {
    return (
        <Box sx={{ width: '100%' }}>
            <TruncatedText
                sx={{
                    fontWeight: '600',
                    fontSize: '14px',
                    paddingTop: '5px',
                }}
                text={text}
            />
        </Box>
    )
}

export default EntityTableHeader
